"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getProjectionFlowKey = exports.Projection = exports.PROJECTION_TARGET_TYPE_CREDIT_LINE = exports.PROJECTION_TARGET_TYPE_EXTERNAL_ACCOUNT = exports.PROJECTION_TARGET_TYPE_CLIENT_GROUP = exports.PROJECTION_TYPE_INTERNAL_ASSUMPTION = exports.PROJECTION_TYPE_EXTERNAL_ASSUMPTION = exports.PROJECTION_TYPE_PREDICTION = exports.PROJECTION_TYPE_MANUAL = exports.PROJECTION_TYPE_UNEXPECTED = exports.PROJECTION_TYPE_PROJECTION = void 0;
exports.PROJECTION_TYPE_PROJECTION = 'PROJECTION';
exports.PROJECTION_TYPE_UNEXPECTED = 'UNEXPECTED';
exports.PROJECTION_TYPE_MANUAL = 'MANUAL';
exports.PROJECTION_TYPE_PREDICTION = 'PREDICTION';
exports.PROJECTION_TYPE_EXTERNAL_ASSUMPTION = 'EXTERNAL_ASSUMPTION';
exports.PROJECTION_TYPE_INTERNAL_ASSUMPTION = 'INTERNAL_ASSUMPTION';
exports.PROJECTION_TARGET_TYPE_CLIENT_GROUP = 'CLIENT_GROUP';
exports.PROJECTION_TARGET_TYPE_EXTERNAL_ACCOUNT = 'ACCOUNT';
exports.PROJECTION_TARGET_TYPE_CREDIT_LINE = 'CREDIT_LINE';
class Projection {
    clone() {
        return Object.assign(new Projection(), this);
    }
}
exports.Projection = Projection;
function getProjectionFlowKey(projection) {
    return [projection.projectionDate, projection.currency, projection.settleDate, projection.direction, projection.desk, projection.productType, projection.targetType, projection.targetName].join('|');
}
exports.getProjectionFlowKey = getProjectionFlowKey;
//# sourceMappingURL=projection.js.map